/**
 * @generated SignedSource<<19e9f33c667212e23385b9f1c5a5defb>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type useAskCopilotSendMessageViaConversationMutation$variables = {
  content: string;
  contentForDisplay?: string | null;
  contextId?: string | null;
  conversationId?: string | null;
  filters?: string | null;
  messageId?: string | null;
  snippetIds?: ReadonlyArray<string> | null;
};
export type useAskCopilotSendMessageViaConversationMutation$data = {
  readonly askCopilotSendMessage: {
    readonly conversation: {
      readonly id: string;
      readonly title: string;
      readonly updatedAt: string;
      readonly " $fragmentSpreads": FragmentRefs<"AskFellowPanelInnerFragment">;
    };
  } | null;
};
export type useAskCopilotSendMessageViaConversationMutation = {
  response: useAskCopilotSendMessageViaConversationMutation$data;
  variables: useAskCopilotSendMessageViaConversationMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "content"
},
v1 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "contentForDisplay"
},
v2 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "contextId"
},
v3 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "conversationId"
},
v4 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "filters"
},
v5 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "messageId"
},
v6 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "snippetIds"
},
v7 = [
  {
    "kind": "Variable",
    "name": "content",
    "variableName": "content"
  },
  {
    "kind": "Variable",
    "name": "contentForDisplay",
    "variableName": "contentForDisplay"
  },
  {
    "kind": "Variable",
    "name": "contextId",
    "variableName": "contextId"
  },
  {
    "kind": "Variable",
    "name": "conversationId",
    "variableName": "conversationId"
  },
  {
    "kind": "Variable",
    "name": "filters",
    "variableName": "filters"
  },
  {
    "kind": "Variable",
    "name": "messageId",
    "variableName": "messageId"
  },
  {
    "kind": "Variable",
    "name": "snippetIds",
    "variableName": "snippetIds"
  }
],
v8 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v9 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "updatedAt",
  "storageKey": null
},
v10 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "title",
  "storageKey": null
};
return {
  "fragment": {
    "argumentDefinitions": [
      (v0/*: any*/),
      (v1/*: any*/),
      (v2/*: any*/),
      (v3/*: any*/),
      (v4/*: any*/),
      (v5/*: any*/),
      (v6/*: any*/)
    ],
    "kind": "Fragment",
    "metadata": null,
    "name": "useAskCopilotSendMessageViaConversationMutation",
    "selections": [
      {
        "alias": null,
        "args": (v7/*: any*/),
        "concreteType": "AskCopilotSendMessage",
        "kind": "LinkedField",
        "name": "askCopilotSendMessage",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "AskCopilotConversation",
            "kind": "LinkedField",
            "name": "conversation",
            "plural": false,
            "selections": [
              (v8/*: any*/),
              (v9/*: any*/),
              (v10/*: any*/),
              {
                "args": null,
                "kind": "FragmentSpread",
                "name": "AskFellowPanelInnerFragment"
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [
      (v3/*: any*/),
      (v0/*: any*/),
      (v1/*: any*/),
      (v5/*: any*/),
      (v6/*: any*/),
      (v2/*: any*/),
      (v4/*: any*/)
    ],
    "kind": "Operation",
    "name": "useAskCopilotSendMessageViaConversationMutation",
    "selections": [
      {
        "alias": null,
        "args": (v7/*: any*/),
        "concreteType": "AskCopilotSendMessage",
        "kind": "LinkedField",
        "name": "askCopilotSendMessage",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "AskCopilotConversation",
            "kind": "LinkedField",
            "name": "conversation",
            "plural": false,
            "selections": [
              (v8/*: any*/),
              (v9/*: any*/),
              (v10/*: any*/),
              {
                "alias": null,
                "args": null,
                "concreteType": "AskCopilotMessage",
                "kind": "LinkedField",
                "name": "messages",
                "plural": true,
                "selections": [
                  (v8/*: any*/),
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "role",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "content",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "contentJson",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "pending",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "createdAt",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "isResponse",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "contentForDisplay",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "error",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "userRating",
                    "storageKey": null
                  }
                ],
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "concreteType": "AskCopilotConversationContext",
                "kind": "LinkedField",
                "name": "context",
                "plural": false,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": null,
                    "kind": "LinkedField",
                    "name": "object",
                    "plural": false,
                    "selections": [
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "__typename",
                        "storageKey": null
                      },
                      (v8/*: any*/)
                    ],
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "haveOngoingBotlessRecording",
                    "storageKey": null
                  }
                ],
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "reachedMessageLimit",
                "storageKey": null
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "bac98634979b34acbe9c29b20b8b4d47",
    "id": null,
    "metadata": {},
    "name": "useAskCopilotSendMessageViaConversationMutation",
    "operationKind": "mutation",
    "text": "mutation useAskCopilotSendMessageViaConversationMutation(\n  $conversationId: ID\n  $content: String!\n  $contentForDisplay: String\n  $messageId: String\n  $snippetIds: [ID!]\n  $contextId: ID\n  $filters: JSONString\n) {\n  askCopilotSendMessage(content: $content, contentForDisplay: $contentForDisplay, conversationId: $conversationId, messageId: $messageId, snippetIds: $snippetIds, contextId: $contextId, filters: $filters) {\n    conversation {\n      id\n      updatedAt\n      title\n      ...AskFellowPanelInnerFragment\n    }\n  }\n}\n\nfragment AskFellowPanelInnerFragment on AskCopilotConversation {\n  id\n  title\n  updatedAt\n  messages {\n    id\n    role\n    content\n    contentJson\n    pending\n    createdAt\n    isResponse\n    contentForDisplay\n    error\n    ...AskFellowPanelInner_ChatMessage_message\n  }\n  ...SuggestedQuestionsWrapper_conversation\n  context {\n    haveOngoingBotlessRecording\n  }\n  reachedMessageLimit\n}\n\nfragment AskFellowPanelInner_ChatMessage_message on AskCopilotMessage {\n  id\n  role\n  content\n  contentJson\n  contentForDisplay\n  pending\n  isResponse\n  error\n  ...AskFellowPanelInner_RatingButtons_message\n}\n\nfragment AskFellowPanelInner_RatingButtons_message on AskCopilotMessage {\n  id\n  userRating\n}\n\nfragment SuggestedQuestionsWrapper_conversation on AskCopilotConversation {\n  context {\n    object {\n      __typename\n      id\n    }\n  }\n}\n"
  }
};
})();

(node as any).hash = "ff9c86d0095fb67f6bd0cd53976f4797";

export default node;
